import { functions } from '@/functions';

/*
    sm_conditions.js
    Функции определяемые пользователями
    x - объект состояние которого обрабатывается
*/

export const sm_conditions = {
    mixins: [functions],
    data: function () {
        return {};
    },
    methods: {
        smIsAdmin: function(x) {
            return this.is_admin;
        },
        smIsAgentOrAgency: function(x) {
            return this.is_admin || this.is_agent_or_agency;
        },
        smIsManagerOrBuh: function(x) {
            return this.is_admin || this.is_manager_or_buh;
        },
        smIsAgentOrManagerWithContactsAccess: function(x) {
            return this.is_admin || this.is_agent_or_agency || this.is_manager_or_buh && x.transfer_by_nsb;
        },
        smIsManagerOrAgentWithContactsAccess: function(x) {
            return this.is_admin || this.is_manager_or_buh || this.is_agent_or_agency;
        },
        smIsClientInvoice: function(x) {
            return !! x.ag_invoice_number;
        },
        smNoActiveBookings: function(x) {
            return !this.smIsActiveBookings(x);
        },
        smIsActiveBookings: function(x) {
            if ((!x.bookings) || (x.bookings===null) || (x.bookings.length===0)) return false;
            let s = this.bookingsSumBill(x);
            return (s>0);
        },
        smBookingsPayedByAgency: function(x) {
            /* */
        },
        smBookingsPayedBySystem: function(x) {
            /* */
        },
        smIsDirectPayment: function(x) {
            return x.m_payment_obj;
        },
        smNotDirectPayment: function(x) {
            return !x.m_payment_obj;
        },
        smIsCheckinPermitted: function(x) {
            return true;
        },
        smNotCheckinPermitted: function(x) {
            return !this.smIsCheckinPermitted();
        },
        smIsBookings: function(x) {
            if ((!x.bookings) || (x.bookings===null) || (x.bookings.length===0)) return false;
            return true;
        },
        smNoBookings: function(x) {
            return !this.smIsBookings(x);
        },
        smHotelCompanyDefined: function(x) {
            if (this.isHotelLoaded()) {
               return !!this.hotel.company_id;
            }
            if (is(x.hotel)) {
                return !!x.hotel.company_id;
            }
            //console.log('smHotelCompanyDefined=false')
            return false;
        },
        smBookingsArePayedByAgency: function(x) {
            // TODO
            return true;
        },
        smIsQuotaFlag: function(x) {
            return x.is_quota;
        },
        smIsNotQuotaFlag: function(x) {
            return ! x.is_quota;
        },
        smIsCallOrDocument: function(x) {
            // TODO
            return true;
        },
        smIsNoCallNoDocument: function(x) {
            // TODO
            return false;
        },
    }

};
